import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoResourceFault, DtoResourceFault } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoResourceFaultEntityDataService } from '../interfaces/dto.resource.fault.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceFaultEntityDataService extends EntityDataService<IDtoResourceFault> implements IDtoResourceFaultEntityDataService {

    constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
        super(http, null, configService, loggingService);
    }

    public getForMandatorByResourceType$(mandator: string, resourceType: string): Observable<IDtoResourceFault[]> {
        return this.httpGet(`/api/web/resourcefault/mandator/${mandator}/resourcetype/${resourceType}`)
            .pipe(map((entities: IDtoResourceFault[]) => {
                const result: IDtoResourceFault[] = [];
                if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
                    for (const entity of entities) {
                        result.push(this.createEntityFromJson(entity));
                    }
                }
                return result;
            }));
    }

    public async getForMandatorByResourceTypeAsync(mandator: string, resourceType: string): Promise<IDtoResourceFault[]> {
        return (await this.getForMandatorByResourceType$(mandator, resourceType).toPromise());
    }

    protected override createEntityFromJson(json: any): IDtoResourceFault {
        const result: IDtoResourceFault = (UtilsJson.deserialize(json, DtoResourceFault) as IDtoResourceFault);
        if (result !== null) {
            result.setReferences();
        }

        return result;
    }

}
